module.exports = __webpack_public_path__ + "static/img/组 2838.0a53b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2838.png
// module id = BYBu
// module chunks = 0